import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSession } from "./SessionProvider";

/**
 * Garantit le parcours d'invitation employé.
 *
 * Le lien d'invitation Supabase signe directement l'employé (session Auth) et
 * le redirige. Selon la configuration Supabase, il peut atterrir ailleurs que
 * sur la page de définition du mot de passe. Pour que l'employé définisse
 * TOUJOURS lui-même son mot de passe (il ne doit jamais en recevoir du DG), ce
 * garde-fou le ramène sur `/reinitialiser-mot-de-passe`.
 *
 * Un compte employé « en attente » correspond exactement à une invitation non
 * encore activée (statut métier « invite » → compte « en_attente »). Aucun autre
 * rôle n'est concerné : propriétaires/agences en attente suivent leur propre
 * parcours, et les comptes actifs/suspendus/désactivés ne sont pas touchés.
 */
const RESET_PASSWORD_PATH = "/reinitialiser-mot-de-passe";

export default function InvitationGuard() {
  const { session, loading } = useSession();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (loading || !session) return;

    const invitationEnCours = session.role === "employe_agence" && session.statut === "en_attente";
    if (invitationEnCours && pathname !== RESET_PASSWORD_PATH) {
      navigate(RESET_PASSWORD_PATH, { replace: true });
    }
  }, [loading, session, pathname, navigate]);

  return null;
}